/**
 * Gives a search reached without a `searchId` (deep link, replayed search) its own, before the
 * page fires any availability call.
 */
export default defineNuxtRouteMiddleware((to) => {
  if (to.query.searchId) return;

  return navigateTo({ path: to.path, query: { ...to.query, searchId: crypto.randomUUID() }, hash: to.hash }, { replace: true });
});
